const state = () => {
  return {
    isShow: false, // 是否显示组件
    downs: [
      // {
      //   path: '', // 路径
      //   loaded: '', // 当前下载的文件大小
      //   fileName: '', // 文件名
      //   size: '', // 要下载的文件总大小
      //   done: false, // 是否完成
      //   createTime: '', // 下载时间
      //   doneTime: '' // 完成时间
      // }
    ]
  }
}

const getters = {}

const mutations = {
  ADD_DOWN: (state, payload) => (state.downs = [...state.downs, payload]),
  UPDATE_DOWN: (state, { payload, index }) => {
    state.downs = state.downs.splice(index, 1, {
      ...state.downs[index],
      ...payload
    })
  }
}

const actions = {
  // 写入下载
  setDown({ state, commit }, payload) {
    // 查找是否已经有任务队列
    const findResIndex = state.downs.findIndex(
      item => item.path === payload.path
    )
    if (findResIndex >= 0) {
      commit('UPDATE_DOWN', { payload, index: findResIndex })
    } else {
      commit('ADD_DOWN', { ...payload, createTime: Date.now() })
    }
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
